export const applySearch = (data, search, definition) => {
  if (!search) {
    return data;
  }

  return data.filter((item) =>
    definition.some((field) => {
      const value = item[field.name];
      if (typeof value !== "string") {
        return false;
      }

      if (field.type === 'start') {
        return value.toLowerCase().startsWith(search.toLowerCase());
      }

      if (field.type === 'end') {
        return value.toLowerCase().endsWith(search.toLowerCase());
      }

      return value.toLowerCase().includes(search.toLowerCase());
    })
  );
}

export const applyPagination = (data, pagination) => {
  if (!pagination) {
    return data;
  }

  const start = (pagination.currentPage - 1) * pagination.perPage;
  const end = start + pagination.perPage;
  return data.slice(start, end);
}

export const applySorting = (data, sorting) => {
  if (!sorting || !sorting.column) return data;

  return [...data].sort((a, b) => {
    const valueA = a[sorting.column];
    const valueB = b[sorting.column];

    if (valueA === valueB) return 0;
    const comparison = valueA > valueB ? 1 : -1;

    return sorting.direction === "asc" ? comparison : -comparison;
  });
};

export const applyFilters = (data, filters) => {
  if (!filters || filters.length === 0) return data;

  return data.filter((item) =>
    filters.every(({ filter, operator, value }) => {
      const fieldValue = item[filter.name];
      switch (operator) {
        case "contains":
          return value.includes(fieldValue);
        case "equals":
          return fieldValue === value;
        case "greater_than":
          return fieldValue > value;
        case "less_than":
          return fieldValue < value;
        default:
          return true;
      }
    })
  );
};

